import { BorderButton } from "src/components/buttons/BorderButton";
import Container from "src/components/layout/Container";
import colors from "src/utils/colors";
import { useListBackground } from "src/utils/setListBackground";

export default function MissingOrganization() {
  useListBackground();

  const host = window.location.hostname;

  return (
    <div className="flex-1">
      <div className="fixed left-0 right-0 top-0 z-20 h-[50px] bg-white shadow">
        <Container full>
          <div className="flex h-[50px] items-center">
            <img
              src="/img/captyn-logo.svg"
              alt="Captyn"
              width="91"
              height="16"
            />
          </div>
        </Container>
      </div>

      <Container className="pb-20 pt-28 sm:pt-20">
        <div className="break-words rounded-lg border border-borderGray bg-white p-8 pb-10">
          <div className="mb-3 text-4xl">🤷‍♂️</div>
          <strong>The website</strong>
          <div className="mb-2 text-4xl font-bold text-organization">
            {host}
          </div>
          <strong>does not exist.</strong>

          <hr className="-mx-8 my-8" />

          <p>
            <strong>What to do?</strong>
            <br />
            Make sure the web address is spelled correctly.
          </p>

          <p>
            If so, contact your organization and let them know the link you
            followed is incorrect.
          </p>

          <div className="my-6 h-[2px] w-8 bg-organization" />

          <p>
            <strong>Does your business rely on registrations?</strong>
            <br />
            You can sign up for Captyn and operate <strong>{host}</strong> right
            now!
          </p>

          <BorderButton
            type="submit"
            bgColor={colors.main}
            borderColor={colors.mainDark}
            textColor={colors.dark}
            href="https://captyn.com"
            target="_blank"
          >
            Learn More
          </BorderButton>
        </div>
      </Container>
    </div>
  );
}
